export function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div
        className="h-8 w-8 rounded-full border-2 border-slate-300 border-t-slate-700 animate-spin"
        role="status"
        aria-label="Загрузка"
      />
    </div>
  );
}
